import { render, staticRenderFns } from "./UploadProductFilesModal.vue?vue&type=template&id=67445fbc&scoped=true&"
import script from "./UploadProductFilesModal.vue?vue&type=script&lang=js&"
export * from "./UploadProductFilesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67445fbc",
  null
  
)

export default component.exports